import { IFamilyGroupManagementFormValueType } from "../Types/familyGroupManagementFormProps"
import { ProductTypeOptions } from "./IFamilyGroupFormField"
import { IFamilyGroupManagementError } from "./IFamilyGroupManagementFormField"

export interface IInitialStateFamilyGroupManagement {
  values: IFamilyGroupManagementFormValueType
  errors: IFamilyGroupManagementError
  submitted: boolean
  dirty: boolean
  setPopup: boolean
}
export const iInitialStateFamilyGroupManagement: IInitialStateFamilyGroupManagement = {
  values: {
    FamilyGroup: "",
    FamilyGroupDescription: "",
    CreatedDate: "",
    UpdatedDate: "",
    ProductType: ProductTypeOptions[0].value,
    UpdatedBy: "",
    LPFamilyGroupMix: true,
    MLPFamilyGroupMix: true,
    SerialControl: "N",
    SerialInputMask: "",
    StrapTotes: false
  },
  errors: {
    FamilyGroup: "",
    FamilyGroupDescription: "",
    CreatedDate: "",
    UpdatedDate: "",
    ProductType: "",
    LPFamilyGroupMix: "",
    MLPFamilyGroupMix: "",
    SerialControl: "",
    SerialInputMask: "",
    UpdatedBy: "",
    StrapTotes: ""
  },
  submitted: false,
  dirty: false,
  setPopup: false
}